import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import SEO from "@/components/site/SEO";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Impressum – FINABLE"
        description="Impressum der FINABLE GmbH: Anbieterkennzeichnung, Kontaktdaten, Handelsregister, Vermittlerregister und Aufsichtsbehörden nach § 5 TMG."
        canonical="https://finable.de/impressum"
      />
      <Header alwaysSolid />
      <main className="pt-32 pb-20">
        <article className="container max-w-3xl prose prose-slate dark:prose-invert">
          <h1 className="font-display text-4xl md:text-5xl font-bold text-primary">Impressum</h1>

          <p className="mt-6">
            FINABLE GmbH<br />
            Gärtnerstraße 26a<br />
            20253 Hamburg
          </p>

          <p>
            Handelsregister: HRB 169734<br />
            Registergericht: Hamburg
          </p>

          <p>
            <strong>Vertreten durch:</strong><br />
            Jann Hikko Kromminga
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Gewerberechtliche Erlaubnis und Aufsichtsbehörde</h2>
          <p>
            Die FINABLE GmbH verfügt über eine Erlaubnis nach § 34c Abs. 1 Satz 1 Nr. 1 Gewerbeordnung (Immobilienmakler: Vermittlung des Abschlusses und Nachweis der Gelegenheit zum Abschluss von Verträgen über Grundstücke, grundstücksgleiche Rechte, gewerbliche Räume oder Wohnräume), erteilt durch das Bezirksamt Eimsbüttel der Freien und Hansestadt Hamburg.
          </p>
          <p><strong>Zuständige Aufsichtsbehörde:</strong></p>
          <p>
            Freie und Hansestadt Hamburg<br />
            Bezirksamt Eimsbüttel<br />
            Zentrum für Wirtschaftsförderung, Bauen und Umwelt<br />
            Grindelberg 62-66<br />
            20144 Hamburg
          </p>


          <h2 className="font-display text-2xl font-bold text-primary mt-10">Kontakt</h2>
          <p>
            Telefon: 040 5724 9358<br />
            Telefax: 040 3567 4497<br />
            E-Mail: <a href="mailto:moin@finable.de" className="text-accent hover:underline">moin@finable.de</a>
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Gewerbeanmeldung</h2>
          <p>
            Die Gewerbeerlaubnis nach Versicherungsmakler mit Erlaubnis nach § 34d Abs. 1 GewO wurde am 30.09.2021 von folgender Stelle erteilt: Handelskammer Hamburg.
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Vermittlerregister</h2>
          <p>
            <a href="https://www.vermittlerregister.info" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">www.vermittlerregister.info</a><br />
            Registrierungs-Nr. für die Versicherungsvermittlung: D-F0L9-4953U-57
            <br />
            Registrierungs-Nr. für die Finanzanlagenvermittlung: D-F-131-JECM-13
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Aufsichtsbehörde</h2>
          <p>
            Handelskammer Hamburg<br />
            Adolphsplatz 1<br />
            20457 Hamburg<br />
            <a href="https://www.ihk.de/hamburg/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">https://www.ihk.de/hamburg/</a>
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Angaben zur Berufshaftpflichtversicherung</h2>
          <p><strong>Name und Sitz des Versicherers:</strong></p>
          <p>
            Allianz Versicherungs-AG<br />
            Königinstr. 28<br />
            80802 München<br />
            <em>– für die Versicherungsvermittlung und die Finanzanlagenvermittlung</em>
          </p>
          <p><strong>Geltungsraum der Versicherungen:</strong> Deutschland</p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">
            Zentrale Kontaktstelle nach dem Digital Services Act – DSA (Verordnung (EU) 2022/2065)
          </h2>
          <p>
            Unsere zentrale Kontaktstelle für Nutzer und Behörden nach Art. 11, 12 DSA erreichen Sie wie folgt:
          </p>
          <p>
            E-Mail: <a href="mailto:moin@finable.de" className="text-accent hover:underline">moin@finable.de</a><br />
            Telefon: 040 5724 9358<br />
            Postalisch: FINABLE GmbH, Gärtnerstraße 26a, 20253 Hamburg
          </p>
          <p>Die für den Kontakt zur Verfügung stehenden Sprachen sind: Deutsch, Englisch.</p>
        </article>
      </main>
      <Footer />
    </div>
  );
}
